var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"popup__button-wrapper"},[_c('div',{staticClass:"popup__buttons popup__buttons--col"},[_c('a',{staticClass:"popup__button popup__button--back",on:{"click":_vm.closePopup}},[_vm._v("Ok! Volver a la página")])])])}
var staticRenderFns = []

export { render, staticRenderFns }